var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#FFE603"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.272 39.314a1 1 0 0 0 1.456 1.372l-1.456-1.372Zm18 1.372a1 1 0 0 0 1.456-1.372l-1.456 1.372ZM35.5 27.5A3.5 3.5 0 0 1 32 31v2a5.5 5.5 0 0 0 5.5-5.5h-2ZM32 31a3.5 3.5 0 0 1-3.5-3.5h-2A5.5 5.5 0 0 0 32 33v-2Zm-3.5-3.5A3.5 3.5 0 0 1 32 24v-2a5.5 5.5 0 0 0-5.5 5.5h2ZM32 24a3.5 3.5 0 0 1 3.5 3.5h2A5.5 5.5 0 0 0 32 22v2Zm-8.272 16.686C25.893 38.389 28.808 37 32 37v-2c-3.795 0-7.222 1.656-9.728 4.314l1.456 1.372ZM32 37c3.191 0 6.107 1.389 8.272 3.686l1.456-1.372C39.222 36.656 35.795 35 32 35v2Z",
  fill: "#171717"
})));
export default SvgUserFilled;